const SAFE_PROTOCOLS = ['http:', 'https:', 'mailto:', 'tel:'];

/**
 * Resolves a markdown `href`/`src` to a value that is safe to put in the DOM.
 *
 * Markdown is frequently authored by someone other than the viewer — an agent, a template, a
 * remote document — so a URL is only kept when it is relative or uses a protocol that cannot
 * execute script. Anything else (`javascript:`, `data:`, `vbscript:`, `file:`) is dropped.
 *
 * @param url - The raw URL as written in the markdown source.
 * @returns The URL when it is safe to render, or an empty string to drop the attribute.
 */
export function transformMarkdownUrl(url: string): string {
  const trimmed = url.trim();
  if (trimmed === '') {
    return '';
  }

  try {
    // A base is required to resolve relative URLs, and its protocol is what they inherit.
    return SAFE_PROTOCOLS.includes(new URL(trimmed, 'https://notablehealth.com').protocol)
      ? trimmed
      : '';
  } catch {
    return '';
  }
}
